// Extracted from src/pages/staff/VisitorStatistics.js (4 KPI cards) in
// PR 12 ST 9. Self-contained — owns the useStatsSummary call. Card values
// fall back to 0 while loading so the layout doesn't jump.

import type { FC } from "react";
import { Eye, Image, Landmark, MapPin, Users } from "lucide-react";

import { useStatsSummary } from "@shared/api/hooks/useStats";

interface CardSpec {
  testid: string;
  label: string;
  value: number;
  icon: typeof Users;
  bg: string;
  fg: string;
}

const SummaryCards: FC = () => {
  const { data: summary } = useStatsSummary();
  const cards: CardSpec[] = [
    {
      testid: "total-visitors-card",
      label: "Total Unique Visitors",
      value: summary?.total_unique_visitors ?? 0,
      icon: Users,
      bg: "bg-blue-100",
      fg: "text-blue-600",
    },
    {
      testid: "total-views-card",
      label: "Total Views",
      value: summary?.total_views ?? 0,
      icon: Eye,
      bg: "bg-green-100",
      fg: "text-green-600",
    },
    // One card per tier, top-down; Total Views is their sum.
    {
      testid: "exhibition-views-card",
      label: "Exhibition Views",
      value: summary?.total_exhibition_views ?? 0,
      icon: Landmark,
      bg: "bg-sky-100",
      fg: "text-sky-600",
    },
    {
      testid: "zone-views-card",
      label: "Zone Views",
      value: summary?.total_zone_views ?? 0,
      icon: MapPin,
      bg: "bg-orange-100",
      fg: "text-orange-600",
    },
    {
      testid: "exhibit-views-card",
      label: "Exhibit Views",
      value: summary?.total_exhibit_views ?? 0,
      icon: Image,
      bg: "bg-purple-100",
      fg: "text-purple-600",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div
            key={card.testid}
            className="bg-white border border-border rounded-lg p-6"
            data-testid={card.testid}
          >
            <div className="flex items-center gap-3">
              <div
                className={`w-12 h-12 ${card.bg} rounded-lg flex items-center justify-center`}
              >
                <Icon className={`w-6 h-6 ${card.fg}`} />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">{card.label}</p>
                <p className="text-3xl font-bold">{card.value}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SummaryCards;
